module.exports = __webpack_public_path__ + "static/media/UI&UXLogo.cb6039b5.svg";